import script from "./SnippetTools.vue?vue&type=script&setup=true&lang=js"
export * from "./SnippetTools.vue?vue&type=script&setup=true&lang=js"

import "./SnippetTools.vue?vue&type=style&index=0&id=526fc296&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-526fc296"]])

export default __exports__